import { Col, Drawer, Row, Space, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import ListItems from "./Components/ListItems";
import { useGetPortfolioUserByStoreFilter } from "./ServerSideStates";
import { useState } from "react";
import AddOrUpdateUser from "./Components/AddOrUpdate/AddOrUpdateUser";
import { useQueryClient } from "react-query";
import endPoints from "./EndPoints";
import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";


const UserManagementIndex = () => {
  const { Text } = Typography;
  const { filter } = useSelector((state: RootState) => state.userManagement);
  const users = useGetPortfolioUserByStoreFilter(filter);
  const [isShowAddDrawer, setIsShowAddDrawer] = useState(false);
  const queryClient = useQueryClient();

  return (
    <>
     <CountinueOnMobileApp
    isShowChildren={false}
    isShowDesc
    noDataSrc="https://cdn-icons-png.flaticon.com/512/11890/11890862.png"
    desc="Kullanıcı Yönetimi sekmesi yalnızca web sürümümüzde görüntülenebilir"
  useInWeb={true}
    >

      <Col xs={24}>
        <Row gutter={[0, 20]} className="!px-16">
          <Col span={24} className="!flex justify-center">
            <Text className="">
              <Space>
                <span className="!text-2xl !font-bold">Kullanıcı Listesi</span>
                <span className="!text-gray-400">
                  ({users?.data?.data?.data?.length || 0} Adet)
                </span>
              </Space>
            </Text>
          </Col>
          <Col xs={24} className="!flex justify-end">
            <MazakaButton
              className="!bg-black !text-white"
              icon={<PlusOutlined />}
              onClick={() => {
                setIsShowAddDrawer(true);
              }}
            >
              Kullanıcı Ekle
            </MazakaButton>
          </Col>
          {/* <Col xs={24} >
          <TopFilters/>
          </Col> */}

          <Col xs={24} className="">
            <ListItems />
          </Col>
        </Row>
      </Col>
    </CountinueOnMobileApp>

      <Drawer
        open={isShowAddDrawer}
        onClose={() => {
          setIsShowAddDrawer(false);
        }}
      >
        <AddOrUpdateUser
          onFinish={() => {
            queryClient.resetQueries({
              queryKey: endPoints.getPortfolioUserByStoreFilter,
              exact: false,
            });
            setIsShowAddDrawer(false);
          }}
        />
      </Drawer>
      <></>
    </>
  );
};

export default UserManagementIndex;
